<template>
	<div class="modal fade" id="one-inbox-new-message" tabindex="-1" role="dialog" aria-labelledby="one-inbox-new-message" style="padding-right: 15px; overflow-y: scroll;" aria-modal="true">
		<!-- <span class="help-block error">{{this.errors.formError}}</span> -->
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<form @submit.prevent="sendPrivateMessage" enctype="multipart/form-data" novalidate>
					<div class="block block-rounded block-themed block-transparent mb-0">
						<div class="block-header bg-primary-dark">
							<h3 class="block-title" v-if="!!newMessage">
								<i class="fa fa-pencil-alt mr-1"></i> New {{title}}
							</h3>
							<h3 class="block-title" v-else>
								<i class="fa fa-pencil-alt mr-1"></i> Replying to: {{replyMsg.senderName}}
							</h3>
							<div class="block-options">
								<button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
									<i class="fa fa-fw fa-times"></i>
								</button>
							</div>
						</div>
						<div class="block-content">
							<div class="form-group" v-if="users && !!newMessage">
								<label for="message-email">Recipients</label>
								<span class="help-block error">{{this.errors.recipientError}}</span>
								<multiselect v-if="newMessage && !newMessage.disableRecipients" v-model="userRecipients" hide-selected name="recipientUserIds" :options="users" :multiple="true" track-by="id" label="name" placeholder="Select Recipients"></multiselect>
								<div v-else>
									<v-expansion-panels class="mb-2">
										<v-expansion-panel>
											<v-expansion-panel-header>{{(userRecipients || []).length}} Recipients</v-expansion-panel-header>
											<v-expansion-panel-content>
												<table id="ticket-table" class="table table-striped admin-form">
													<thead>
													<tr>
														<th>Name</th>
														<th>Email</th>
													</tr>
													</thead>
													<tbody id="recipientBody">
														<tr v-for="recipient in userRecipients" :key="recipient.id">
															<td>{{recipient.name}}</td>
															<td>{{recipient.email}}</td>
														</tr>
													</tbody>
												</table>
											</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
								</div>
							</div>
							<div class="form-group">
								<label for="message-msg">Subject</label>
								<span class="help-block error">{{this.errors.subjectError}}</span>
								<input type="text" class="form-control" v-model="privateMessage.subject">
							</div>
							<div class="form-group">
								<label for="message-msg">Message</label>
								<span class="help-block error">{{this.errors.messageError}}</span>
<!--								<textarea class="form-control form-control-alt" id="message-msg" name="message" rows="6" v-model="privateMessage.message"></textarea>-->
								<type-wysiwyg v-model="privateMessage.message" :type="'WYSIWYG'" :validation_settings="{}" :settings="{allowed_extensions:['Bold', 'Underline', 'Italic', 'ListItem', 'BulletList', 'OrderedList']}"></type-wysiwyg>
							</div>
							<div class="form-group">
								<label for="message-images">Add Image(s)</label>
									<div class="dropbox">
										<input
											id="message-images"
											type="file"
											ref="imageInput"
											name="attachments[]"
											multiple
											@change="imageUpload()"
											accept="image/*,application/pdf"
											class="input-file"
										>
										<p v-if="isUpdating">
											<span class="spinner-border spinner-border-sm text-primary" role="status"></span> Uploading files...
										</p>
										<p v-else>
											Drag your file(s) here to begin<br> or click to browse
										</p>
									</div>
								<p v-for="(f,i) in imageFiles" :key="`media-${i}`" class="block-content mb-0 d-flex align-items-center justify-content-between image-file-remove">
									{{ f.name }}
									<button class="btn btn-sm btn-danger" type="button" @click="removeMedia(i)">
										Remove
									</button>
								</p>
							</div>
							<v-expansion-panels class="mb-2" v-if="newMessage && newMessage.canTest">
								<v-expansion-panel>
									<v-expansion-panel-header>Test Message</v-expansion-panel-header>
									<v-expansion-panel-content>
										<div class="form-group" >
											<label for="message-msg">Email(s) to Send Test</label>
											<input type="text" class="form-control" v-model="testEmail">
											<span class="font-size-sm">Send Test will only send to this (these). Comma separate for multiple emails.</span>
										</div>
										<div class="d-flex flex-fill justify-content-end">
											<button type="button" class="btn btn-secondary" :disabled="isUpdating || !testEmail" @click.prevent="sendPrivateMessage(null, true)">
												<i class="fa fa-paper-plane mr-1"></i> Send Test
											</button>
										</div>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
						<div class="block-content block-content-full text-right border-top">
							<button type="button" class="btn btn-alt-primary mr-1" data-dismiss="modal" id="close-new-message">Cancel</button>
							<button type="submit" class="btn btn-primary" :disabled="isUpdating">
								<i class="fa fa-paper-plane mr-1"></i> Send Message
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>

	import TypeWysiwyg from "../FormComponents/DynamicForm/fields/TypeWYSIWYG";

export default {
	components: {
		TypeWysiwyg,
	},
	props: {
		// users is given for the array for them to select.
		users: {
			type: Array,
			default() {
				return []
			}
		},
		replyMsg: {
			type: Object,
			default() {
				return {}
			}
		},
		friendMessage: {
			type: Object,
			default() {
				return {}
			}
		},
		newMessage: {
			type: Boolean | Object,
			default() {
				return {};
			}
		},
		//recipients is who this will go to.
		recipients: {
			type: Array,
			default() {
				return []
			}
		},
		venueId: {
			type: Number,
			default: null
		}
	},
	data: () => {
		return {
			title: "MESSAGE",
			errors: [],
			privateMessage: {
				message: '',
			},
			partner_id: window.bwPartnerId,
			imageFiles: [],
			uploadError: null,
			currentStatus: null,
			valid: false,
			isUpdating: false,
			isInitial: true,
			testEmail:'',
		}
	},
	watch: {
		newMessage: {
			deep: true,
			handler(o, n) {
				this.privateMessage = {...this.privateMessage, ...this.newMessage};
			}
		}
	},
	computed: {
		userRecipients: {
			get() {
				return this.recipients
			},
			set(v) {
				this.$emit('recipient-update', v)
			}
		},
	},
	methods: {
		async sendPrivateMessage(parentId, isTest=false) {
			if(this.validate()) {
				this.isUpdating = true

				if( !isTest )
					document.getElementById("close-new-message").click()

				try {
					await axios.post(`/privateMessages`, this.formifyMessage(isTest));
                    this.isUpdating = false
                    if( !isTest )
                        this.imageFiles = []
					let timerInterval
					Bandwango.helpers('swal', {
						title: 'Your '+(isTest ? 'test ' : '')+'message is sending...',
						html: isTest ? 'Dont close anything and review your test email.' : 'Enjoy your day!',
						timer: 2500,
						timerProgressBar: true,
						didOpen: () => {
							Bandwango.helpers('swal').showLoading()
							timerInterval = setInterval(() => {
								const content = Bandwango.helpers('swal').getContent()
								if (content) {
									const b = content.querySelector('b')
									if (b) {
										b.textContent = Bandwango.helpers('swal').getTimerLeft()
									}
								}
							}, 100)
						},
						willClose: () => {
							clearInterval(timerInterval)
						}
					})
					if( isTest ) {
						this.testEmail = '';
						return;
					}
					this.$emit('resetMsg', true)
				}
				catch(err) {
					let timerInterval
                    const message = 'Try again or talk to an admin if the error continues.' +
                        err.response?.data?.message ? `         ${err.response.data.message}` : '';
                    Bandwango.helpers('swal', {
						title: 'Something went wrong:',
						html: message,
						timer: 6500,
						timerProgressBar: true,
						didOpen: () => {
							Bandwango.helpers('swal').showLoading()
							timerInterval = setInterval(() => {
								const content = Bandwango.helpers('swal').getContent()
								if (content) {
									const b = content.querySelector('b')
									if (b) {
										b.textContent = Bandwango.helpers('swal').getTimerLeft()
									}
								}
							}, 100)
						},
						willClose: () => {
							clearInterval(timerInterval)
						}
					})
					console.error(err)
				}
			}
			else {
				console.log("validation error...");
			}
			this.privateMessage.message = ''
			this.privateMessage.subject = ''
		},
		validate() {
			this.errors = [];
			if(this.privateMessage.message == false) {
				this.errors['messageError'] = 'You need to have a message to send this.';
			}
			if(this.recipients.length == 0 && !this.replyMsg && !this.testEmail) {
				this.errors['recipientError'] = 'You need to have recipient(s) to send this.';
			}
			if (Object.keys(this.errors).length === 0) {
				this.valid = true
				return true;
			}
			return false
		},
		reset() {
			this.uploadError = null;
			this.imageFiles = []
		},
		imageUpload() {
			this.isUpdating = true
			this.imageFiles = [...this.imageFiles, ...Object.values(this.$refs.imageInput.files)] //appending new files
			this.$refs.imageInput.value = null // were tracking internally. resetting this so we can re upload.
			if(this.imageFiles) {
				setTimeout(() => {
					this.isUpdating = false
				}, 3000);
			}
		},

		removeMedia(i) {
			this.imageFiles.splice(i, 1)
			delete this.$refs.imageInput.files[i]
		},

		formifyMessage(isTest=false) {
			let formData = new FormData()

			// make formData match data object
			Object.keys(this.privateMessage).forEach(k => {
				formData.append(k, this.privateMessage[k])
			})

			if( isTest )
				formData.append('testEmail', this.testEmail);

			if( this.venueId )
				formData.append('params[venueId]', this.venueId);

			// format array things
			if(Object.keys(this.replyMsg).length > 0) {
				formData.append('recipientUserIds[]', this.replyMsg.sender_user_id)
				formData.append('parent_id', this.replyMsg.id)
			}
			else this.recipients.forEach(r => formData.append('recipientUserIds[]', r.id))

			this.imageFiles.forEach((file, idx) => formData.append('attachments[]', file))
            if(this.newMessage.blankTemplate) {
                formData.append('params[blankTemplate]', this.newMessage.blankTemplate)
            }

			return formData
		}
	},
	mounted() {
		this.reset();

		if( this.newMessage?.subject ) this.privateMessage.subject = this.newMessage.subject;
		if( this.newMessage?.message ) this.privateMessage.message = this.newMessage.message;
	}
}
</script>

<style lang="scss">
	.dropbox {
		outline: 2px dashed grey;
		outline-offset: -10px;
		background: lightsteelblue;
		color: dimgray;
		padding: 10px 10px;
		min-height: 200px;
		position: relative;
		cursor: pointer;
		border-radius: 4px;
	}

	.input-file {
		opacity: 0;
		width: 100%;
		height: 200px;
		position: absolute;
		cursor: pointer;
	}

	.dropbox:hover {
		background: rgb(161, 214, 231); /* when mouse over to the drop zone, change color */
	}

	.dropbox p {
		font-size: 1.2em;
		text-align: center;
		padding: 50px 0;
	}

	.list-unstyled{
		display: flex;
	}

	.img-thumbnail {
		max-height: 150px;
	}

	.error {
		color: red;
		font-weight: bold;
	}

	.image-file-remove {
		padding: 15px 0;
		transition: all .5s ease-in-out;
		margin-bottom: 0;
		&:first-child {
			margin-top: 10px;
		}
		&:hover {
			background-color: #f1f1f1;
		}
	}

</style>
